export default __webpack_public_path__ + "static/media/Decarbonise_2021March.45b1c281.zip";